interface TimeParams {
  start?: number;
  end?: number;
}

export const parseTimeParams = (url: string): TimeParams => {
  try {
    // Use base URL for relative URLs, the fallback is just an example so we can build the URL object even if the URL is relative
    const urlObj = new URL(url, 'https://example.com');
    const params = urlObj.searchParams;

    // Check for 't' parameter (format: t=start,end or t=start)
    const tParam = params.get('t');
    if (tParam) {
      const timeParts = tParam.split(',').map((t) => parseFloat(t));

      return {
        start: !isNaN(timeParts[0]) ? timeParts[0] : undefined,
        end: !isNaN(timeParts[1]) ? timeParts[1] : undefined,
      };
    }

    // Check for separate start/end parameters
    const startParam = params.get('start');
    const endParam = params.get('end');

    return {
      start: startParam ? parseFloat(startParam) : undefined,
      end: endParam ? parseFloat(endParam) : undefined,
    };
  } catch {
    // If URL parsing fails, return empty params
    return {};
  }
};
